'use client'

import React from 'react'
import { useCart } from '@/lib/hooks'
import { formatPrice } from '@/lib/utils'

import { RibbonCard } from '@/components/ui'

export const CartSummary = () => {
  const { cart, totalPayable } = useCart()

  const totals = cart?.cart_totals?.map((line: any) => {
    if (line?.type === 'final_payble_amount' || line?.type === 'total') return
    return {
      label: line?.total_name,
      value: formatPrice(line?.amount, 2, false),
    }
  })

  return (
    <RibbonCard
      className="bg-gray-50"
      ribbonClassName="after:bg-white before:bg-white"
      listClassName="text-gray-950"
      highlightsClassName="text-sm"
      list={totals}
      highlightList={[
        {
          label: 'Total Payable',
          value: formatPrice(totalPayable, 2, false),
        },
      ]}
    />
  )
}
